import { PageTransfersAchBatchView } from './View';

export const ACH_BATCHES = {
  AchBatchView: PageTransfersAchBatchView,
} as const;
